import { render, staticRenderFns } from "./SkillsData.vue?vue&type=template&id=82b258aa&scoped=true&"
import script from "./SkillsData.vue?vue&type=script&lang=js&"
export * from "./SkillsData.vue?vue&type=script&lang=js&"
import style0 from "./SkillsData.vue?vue&type=style&index=0&id=82b258aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b258aa",
  null
  
)

export default component.exports